import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["maxLeads", "costEstimate", "campaignSelect"]

  connect() {
    if (this.hasMaxLeadsTarget) this.updateCost()
  }

  open() {
    this.element.classList.remove("hidden")
  }

  close() {
    this.element.classList.add("hidden")
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }

  updateCost() {
    if (!this.hasMaxLeadsTarget || !this.hasCostEstimateTarget) return

    const count = parseInt(this.maxLeadsTarget.value) || 0
    this.costEstimateTarget.textContent = `~${count} crédits Apollo`
  }
}
